import _classCallCheck from "/builds/zappy-ride/client-burbank-ev/frontend/application/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/zappy-ride/client-burbank-ev/frontend/application/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import sort from './sort';
import _range from './range';
import _within from './within';

var defaultGetX = function defaultGetX(p) {
  return p[0];
};

var defaultGetY = function defaultGetY(p) {
  return p[1];
};

var KDBush = /*#__PURE__*/function () {
  function KDBush(points) {
    var getX = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultGetX;
    var getY = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultGetY;
    var nodeSize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 64;
    var ArrayType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : Float64Array;

    _classCallCheck(this, KDBush);

    this.nodeSize = nodeSize;
    this.points = points;
    var IndexArrayType = points.length < 65536 ? Uint16Array : Uint32Array;
    var ids = this.ids = new IndexArrayType(points.length);
    var coords = this.coords = new ArrayType(points.length * 2);

    for (var i = 0; i < points.length; i++) {
      ids[i] = i;
      coords[2 * i] = getX(points[i]);
      coords[2 * i + 1] = getY(points[i]);
    }

    sort(ids, coords, nodeSize, 0, ids.length - 1, 0);
  }

  _createClass(KDBush, [{
    key: "range",
    value: function range(minX, minY, maxX, maxY) {
      return _range(this.ids, this.coords, minX, minY, maxX, maxY, this.nodeSize);
    }
  }, {
    key: "within",
    value: function within(x, y, r) {
      return _within(this.ids, this.coords, x, y, r, this.nodeSize);
    }
  }]);

  return KDBush;
}();

export { KDBush as default };